import createIcon from '../../createIcon';

/**
 * @component @name TurnSharpLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy41IDYuODNMNS45MSA4LjQxTDQuNSA3TDguNSAzTDEyLjUgN0wxMS4wOSA4LjQxTDkuNSA2LjgzVjEzSDE3LjVDMTguNiAxMyAxOS41IDEzLjkgMTkuNSAxNVYyMUgxNy41VjE1SDkuNUM4LjQgMTUgNy41IDE0LjEgNy41IDEzVjYuODNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurnSharpLeft = createIcon('TurnSharpLeft', [
  [
    'path',
    {
      d: 'M7.5 6.83L5.91 8.41L4.5 7L8.5 3L12.5 7L11.09 8.41L9.5 6.83V13H17.5C18.6 13 19.5 13.9 19.5 15V21H17.5V15H9.5C8.4 15 7.5 14.1 7.5 13V6.83Z',
      key: '1qx1b1',
    },
  ],
]);

export default TurnSharpLeft;
